export default __webpack_public_path__ + "static/media/pic40.26ab7d24.jpg";